export const fetchAuthUrlWithService = (baseUrl, destination) => {
    if (typeof window === 'object') {
        const servicePath = `/list/validate-ticket?origin=${encodeURIComponent(destination)}`;
        const service = `${window.location.protocol}//${window.location.host}${servicePath}`;
        const serviceComponent = `service=${encodeURIComponent(service)}`;
        // Add as a first or trailing query parameter
        // depending on if baseUrl already contains a query parameter
        return baseUrl.indexOf('?') !== -1
            ? `${baseUrl}&${serviceComponent}` : `${baseUrl}?${serviceComponent}`;
    }
    return '';
};

export default {
    fetchAuthUrlWithService
};
